import { render, staticRenderFns } from "./Accelerate.vue?vue&type=template&id=52928df8&scoped=true&"
import script from "./Accelerate.vue?vue&type=script&lang=js&"
export * from "./Accelerate.vue?vue&type=script&lang=js&"
import style0 from "./Accelerate.vue?vue&type=style&index=0&id=52928df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52928df8",
  null
  
)

export default component.exports